import React from "react";
import { FaCamera } from "react-icons/fa";

export default function CapteurList({ filteredCapteurs, handleCapteurClick }) {
  if (filteredCapteurs.length === 0) {
    return (
      <div className="bg-gray-50 rounded-xl px-4 py-3 mt-3 text-sm text-gray-400 text-center">
        Aucun compteur trouvé.
      </div>
    );
  }

  return (
    <ul className="space-y-2 mt-3 max-h-56 overflow-y-auto">
      {filteredCapteurs.map((capteur) => (
        <li
          key={capteur._id}
          onClick={() => handleCapteurClick(capteur)}
          className="flex items-center gap-3 px-4 py-3 cursor-pointer bg-white border border-gray-200 rounded-lg text-sm text-gray-700 hover:border-blue-400 hover:bg-blue-50 transition-colors duration-150"
        >
          <FaCamera className="text-blue-400 shrink-0" />
          {capteur.nom_camera || 'Sans nom'}
        </li>
      ))}
    </ul>
  );
}